// export default ModalDialogMotionEditForm
import { useState, useEffect, useContext } from 'react'
import iconVinculos from '../../../../../../../assets/iconosCardInformes/informe_9.png'
import iconPrevired from '../../../../../../../assets/iconosBancos/previred-logo.png'
import { CentroCostosAPI } from '../../../../../../../api/centroCostos.api'
import { Button } from '../../../../../ui/index'
import { formatCurrency } from '../../../../../../utils/formatter'
import Lottie from 'lottie-react'
import { Box } from '@mui/material'
import LoaderMain from '../../../../../../..//assets/svgIcons/loaderMain.json'
// ui
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined'
import GlobalContext from '../../../../../../../context/global-context'
import ResizableModal from '../../../../../ui/ResizableModal'
import { BankAPI } from '../../../../../../../api/bancos.api'

// Colores para cada centro de costo (hasta 10)
const CENTER_COLORS = [
  '#00C6B3',
  '#FF6B6B',
  '#4F46E5',
  '#F59E0B',
  '#EC4899',
  '#10B981',
  '#3B82F6',
  '#A855F7',
  '#F97316',
  '#22C55E'
]

const buildCentroCostoPayload = rows => {
  return rows
    .filter(row => row.centroCostoId && row.porcentaje > 0)
    .map(row => ({
      idCentroCosto: Number(row.centroCostoId),
      porcentajeCentroCosto: row.porcentaje
      // idArea / porcentajeArea opcionales si algún día los usas:
      // idArea: row.idArea ? Number(row.idArea) : null,
      // porcentajeArea: row.porcentajeArea ?? null,
    }))
}

/** Círculo de progreso con segmentos por centro de costo */
const CircleProgress = ({ rows }) => {
  const total = Math.min(
    100,
    rows.reduce((acc, r) => acc + (Number(r.porcentaje) || 0), 0)
  )
  let offset = 0
  const stops = []

  rows.forEach(row => {
    const pct = Math.max(0, Math.min(100 - offset, Number(row.porcentaje) || 0))
    if (pct <= 0) return
    const color = row.color || '#00C6B3'
    stops.push(`${color} ${offset}% ${offset + pct}%`)
    offset += pct
  })

  if (offset < 100) {
    stops.push(`#E5E7EB ${offset}% 100%`)
  }

  const background = `conic-gradient(${stops.join(', ')})`

  return (
    <div className='flex flex-col items-center mt-3'>
      <div
        className='w-20 h-20 rounded-full flex items-center justify-center'
        style={{ background }}
      >
        <span className='text-xs font-semibold'>{total}%</span>
      </div>
      <span className='mt-1 text-[11px] text-gray-500 text-center'>
        Distribución % centros de costo
      </span>
    </div>
  )
}

const isForbiddenCentroName = name =>
  name?.trim().toLowerCase() === 'estado de resultados consolidado'.toLowerCase()

const ModalCentroCosto = ({ open, setOpen, tipoLibro, idLibro, setSwitchGetData }) => {
  const { ui, currentBusiness } = useContext(GlobalContext)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({})
  const bankAPI = new BankAPI()
  const centroCostosAPI = new CentroCostosAPI()
  const [reloadData] = useState(false)
  const [, setReload] = useState(false)
  const [hasInitializedCentroFromData, setHasInitializedCentroFromData] = useState(false)
  const [centroCostoError, setCentroCostoError] = useState('')
  const buildInitialRows = (count = 2) =>
    Array.from({ length: count }).map((_, i) => ({
      centroCostoId: '',
      porcentaje: 0,
      color: CENTER_COLORS[i % CENTER_COLORS.length]
    }))

  const getAvailableCentroCostosCount = () => {
    if (!Array.isArray(centroCostos)) return 0

    return centroCostos.filter(cc => !isForbiddenCentroName(cc.name)).length
  }
  const [centrosCostoRows, setCentrosCostoRows] = useState(buildInitialRows(2))
  const [centroCostos, setCentroCostos] = useState([])
  const [, setInitialLibroPayload] = useState(null)
  const [initialCentroCostoPayload, setInitialCentroCostoPayload] = useState(null)
  const [, setInitializedLibroPayload] = useState(false)

  const getData = async () => {
    try {
      setLoading(true)
      const response = await bankAPI.getDataLibros(currentBusiness?.id, idLibro)
      setData(response.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (open) {
      getData()
    }
  }, [])

  const handleClose = () => {
    setOpen(false)
  }

  const getCentroCostos = async () => {
      try {
        const response = await centroCostosAPI.getCentroCostos(currentBusiness.id)
        setCentroCostos(response.data)
      } catch (error) {
        console.error('Error al cargar los centros de costo:', error)
        throw error
      }
    }
  
    useEffect(() => {
      getCentroCostos()
    }, [])

  const getCentroCostoOptionsForRow = index => {
    if (!Array.isArray(centroCostos)) return []

    const fromApi = centroCostos
      .filter(cc => !isForbiddenCentroName(cc.name))
      .map(cc => ({
        id: cc.id,
        nombreCuenta: cc.name
      }))
    return fromApi
  }

  const CustomSelect = ({ label, name, options, value, onChange, disabled }) => (
    <div className='relative flex flex-col items-start'>
      {label && (
        <label
          htmlFor={name}
          className='absolute top-[-15px] left-4 bg-transparent text-xs font-medium text-gray-500'
        >
          {label}
        </label>
      )}
      <select
        className='h-9 w-full appearance-none focus:outline-none border border-gray-300 hover:border-gray-400 focus:border-gray-400 px-4 py-2 rounded-full shadow leading-tight text-xs'
        name={name}
        onChange={onChange}
        value={value}
        disabled={disabled}
      >
        <option value='' disabled hidden>
          Seleccione una opción
        </option>
        {options.map(option => (
          <option key={option.id} value={option.id}>
            {option.nombreCuenta}
          </option>
        ))}
      </select>
    </div>
  )

  const handleCentroCostoRowChange = (index, field, value) => {
    setCentrosCostoRows(prev => {
      const clone = [...prev]

      if (field === 'porcentaje') {
        const parsed = value === '' ? '' : Math.max(0, Math.min(100, Number(value) || 0))
        clone[index] = {
          ...clone[index],
          porcentaje: parsed
        }
      } else {
        clone[index] = {
          ...clone[index],
          [field]: value
        }
      }
      return clone
    })
    setCentroCostoError('')
  }

  const addCentroCostoRow = () => {
    setCentrosCostoRows(prev => {
      const maxRows = getAvailableCentroCostosCount() 
      if (maxRows > 0 && prev.length >= maxRows) {
        return prev
      }
      const nextIndex = prev.length
      const newRow = {
        centroCostoId: '',
        porcentaje: 0,
        color: CENTER_COLORS[nextIndex % CENTER_COLORS.length]
      }
      return [...prev, newRow]
    })
    setCentroCostoError('')
  }

  const removeCentroCostoRow = index => {
    setCentrosCostoRows(prev => {
      return prev.filter((_, i) => i !== index)
    })
    setCentroCostoError('')
  }

  const clearCentroCostoRows = () => {
    setCentrosCostoRows([])
    setCentroCostoError('')
  }


  useEffect(() => {
    if (data.linkage) {
      setReload(prev => !prev)
    }
  }, [data])

  const handleSubmit = async () => {
    try {
      ui.setLoader({ visible: true })
      // limpiamos cualquier error previo
      setCentroCostoError('')

      // 2) Payload de centros de costo (ARRAY)
      const centroCostoPayload = buildCentroCostoPayload(centrosCostoRows)
      const temporalidad = Number(data.validation ?? 0) || 0

      // 4) Detectar cambios en el payload de centros de costo
      const hasCentroCostoChanges = initialCentroCostoPayload
        ? JSON.stringify(centroCostoPayload) !== JSON.stringify(initialCentroCostoPayload)
        : centroCostoPayload.length > 0

      // 5) SOLO si hubo cambios en centros de costo Y hay algo en el payload,
      //    validamos suma = 100% y que no se repitan IDs.
      if (hasCentroCostoChanges && centroCostoPayload.length > 0) {
        const totalPorcentaje = centroCostoPayload.reduce(
          (acc, item) => acc + (item.porcentajeCentroCosto || 0),
          0
        )

        if (totalPorcentaje !== 100) {
          setCentroCostoError('La suma de los porcentajes de centros de costo debe sumar 100%.')
          return
        }

        const ids = centroCostoPayload.map(item => item.idCentroCosto)
        const idsSet = new Set(ids)

        if (idsSet.size !== ids.length) {
          setCentroCostoError('No puedes usar el mismo centro de costo en más de una fila.')
          return
        }
      }

      const promises = []

      if (hasCentroCostoChanges) {
        promises.push(
          centroCostosAPI.createLibroCentroCosto(
            currentBusiness?.id,
            idLibro,
            centroCostoPayload,
            temporalidad
          )
        )
      }

      // Si no hay nada que enviar, sólo cerramos
      if (promises.length === 0) {
        handleClose()
        return
      }

      await Promise.all(promises)

      setSwitchGetData(true)
      getData()
      handleClose()
    } catch (error) {
      console.error(error)
    } finally {
      ui.setLoader({ visible: false })
    }
  }

  useEffect(() => {
      if (open) {
        setInitialLibroPayload(null)
        setInitialCentroCostoPayload(null)
        setInitializedLibroPayload(false)
        setHasInitializedCentroFromData(false)
  
        getData()
        setData(prevData => ({
          ...prevData,
          validation: prevData.validation ?? ''
        }))
      }
    }, [reloadData, open])
  
    useEffect(() => {
      if (!open) return
  
      // 1) Aún no se ha cargado la data del back → no hacer nada
      if (typeof data.centro === 'undefined') {
        return
      }
  
      // 2) Ya inicializamos una vez con la data actual
      if (hasInitializedCentroFromData) return
  
      const hasCentros = Array.isArray(data.centro) && data.centro.length > 0
  
      if (hasCentros) {
        // Creamos filas a partir de data.centro
        const rowsFromData = data.centro.map((item, index) => ({
          centroCostoId: String(item.centroCostoId), // value = centroCostoId
          porcentaje: item.porcentajeCentroCosto ?? 0,
          color: CENTER_COLORS[index % CENTER_COLORS.length]
        }))
  
        setCentrosCostoRows(rowsFromData)
        setInitialCentroCostoPayload(buildCentroCostoPayload(rowsFromData))
      } else {
        // Sin centros asociados → comportamiento anterior: 2 filas vacías
        const initialRows = buildInitialRows(2)
        setCentrosCostoRows(initialRows)
        setInitialCentroCostoPayload(buildCentroCostoPayload(initialRows))
      }
  
      setHasInitializedCentroFromData(true)
    }, [open, data.centro, hasInitializedCentroFromData])

  const maxCentroRows = getAvailableCentroCostosCount()

  return (
    <ResizableModal
      open={open}
      onClose={handleClose}
      width={1200}
      height={680}
      footer={
        <>
          <Button
            onClick={handleClose}
            className='uppercase text-sm bg-primary text-white rounded-full'
            title='cerrar'
          />
          <Button
            className='uppercase text-sm text-white rounded-full bg-accent2'
            onClick={handleSubmit}
            title='guardar cambios'
          />
        </>
      }
    >
    <>
        {loading ? (
            <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
            <Lottie animationData={LoaderMain} loop autoplay style={{ width: 100, height: 100 }} />
            </Box>
        ) : (
      <>
        <div className='px-4 md:px-8 lg:px-12 mt-2 max-h-[70vh] overflow-y-auto pb-2'>
          <div className='w-full mx-auto'>
            {/* Cabecera documento */}
            <section className='bg-white shadow-lg px-3 py-2 rounded-3xl gap-6'>
              <div className='flex justify-between items-start mb-1 pb-1'>
                {/* Bloque izquierdo: documento + folio + fecha */}
                <div className='flex gap-2'>
                {tipoLibro === 'liquido' ? (
                    <img className='w-11 h-11 border' src={iconVinculos} alt='' />
                  ) : (
                    <img className='w-11 h-11 border' src={iconPrevired} alt='' />
                )}
                  <div className='flex flex-col'>
                    <p className='text-[12px] font-bold uppercase leading-5'>
                      {tipoLibro === 'liquido' ? 'REMUNERACIONES' : 'PREVIRED'}
                    </p>
                    <div className='flex items-center gap-1 text-[12px] leading-tight'>
                      <span>{data.rut}</span>
                    </div>
                  </div>
                </div>

                <div className='flex flex-col items-end text-right text-[10px] min-w-[110px] whitespace-nowrap '>
                  {tipoLibro === 'liquido' ? (
                    <>
                      <span className='text-accent3'>{data.status}</span>
                      <p className='text-[12px] font-semibold leading-tight'>
                        Sueldo Líquido: {formatCurrency(data.montoTotal)}
                      </p>
                    </>
                  ) : (
                    <>
                      <span className='text-accent3'>{data.statusPrevired}</span>
                      <p className='text-[12px] font-semibold leading-tight'>
                        Previred: {formatCurrency(data.montoNeto)}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </section>

            {/* Ajustes de Clasificación */}
            <section className='w-full p-4 mt-3 border-2 rounded-3xl h-auto shadow-lg'>
              <h2 className='text-sm font-semibold mb-2'>Ajustes de Clasificación</h2>

              <div className='flex flex-wrap gap-6'>
                {/* IZQUIERDA */}
                <div className='flex flex-col flex-1 min-w-[260px] gap-6 mt-3'>
                  <div className='relative flex flex-col items-start'>
                    <label className='absolute top-[-15px] left-4 bg-transparent text-xs font-medium text-gray-500'>
                      Tipo
                    </label>
                    <select
                      className='h-9 appearance-none focus:outline-none border border-gray-300 hover:border-gray-400 focus:border-gray-400 px-4 py-2 rounded-full shadow leading-tight text-xs w-full pl-4'
                      name='validation'
                      id='validation'
                      value={data.nombreCuenta}
                      disabled
                    >
                     <option value='' disabled hidden>
                        Seleccione temporalidad
                      </option>
                      <option value={1}>{data.nombreCuenta}</option>
                    </select>
                  </div>

                  <div className='relative flex flex-col items-start'>
                    <label className='absolute top-[-15px] left-4 bg-transparent text-xs font-medium text-gray-500'>
                      Temporalidad
                    </label>
                    <select
                      className='h-9 appearance-none focus:outline-none border border-gray-300 hover:border-gray-400 focus:border-gray-400 px-4 py-2 rounded-full shadow leading-tight text-xs w-full pl-4'
                      name='validation'
                      id='validation'
                    >
                      <option value='' disabled hidden>
                        Seleccione temporalidad
                      </option>
                      <option value={1}>Aplicar sólo a este registro</option>
                      <option value={2}>Recordar esta selección en el futuro</option>
                      <option value={3}>Aplicar esta selección a todos los registros</option>
                    </select>
                  </div>


                  <CircleProgress rows={centrosCostoRows} />
                </div>

                {/* DERECHA: centros de costo + porcentajes */}
                <div className='flex flex-col flex-1 min-w-[320px] gap-4 max-h-72 overflow-y-auto pr-2'>
                  <div className='grid grid-cols-2 gap-4'>
                    {/* Centros de costo */}
                    <div className='flex flex-col mt-6 gap-2'>
                      {centrosCostoRows.map((row, index) => (
                        <div key={index} className='mb-4'>
                          <CustomSelect
                            label='Centro de costo'
                            name={`centroCosto-${index}`}
                            options={getCentroCostoOptionsForRow(index)}
                            value={row.centroCostoId}
                            onChange={e =>
                              handleCentroCostoRowChange(index, 'centroCostoId', e.target.value)
                            }
                            disabled={data.validation === -5}
                          />
                        </div>
                      ))}

                      <div className='mt-1 flex w-full items-center justify-between font-sans'>
                        <button
                          type='button'
                          className={`text-xs ${
                            maxCentroRows > 0 && centrosCostoRows.length >= maxCentroRows
                              ? 'text-gray-400 cursor-not-allowed'
                              : 'text-accent3'
                          }`}
                          onClick={addCentroCostoRow}
                          disabled={
                            data.validation === -5 ||
                            (maxCentroRows > 0 && centrosCostoRows.length >= maxCentroRows)
                          }
                        >
                          + Agregar centro de costo
                        </button>
                        <button
                          type='button'
                          className={`text-xs ${
                            data.validation === -5 || centrosCostoRows.length === 0
                              ? 'text-gray-400 cursor-not-allowed'
                              : 'text-red-500 hover:text-red-600'
                          }`}
                          onClick={clearCentroCostoRows}
                          disabled={data.validation === -5 || centrosCostoRows.length === 0}
                        >
                          - Quitar asignación
                        </button>
                      </div>
                    </div>
                    {/* Porcentajes */}
                    <div className='flex flex-col'>
                      {centrosCostoRows.map((row, index) => (
                        <div key={index}>
                          <label className='text-xs text-gray-500'>Porcentaje</label>
                          <div className='flex items-center gap-2'>
                            <input
                              type='number'
                              min={0}
                              max={100}
                              className='h-9 w-full border border-gray-300 rounded-full px-3 py-1 text-xs focus:outline-none focus:border-gray-400'
                              value={row.porcentaje === 0 ? '' : row.porcentaje}
                              onFocus={() => {
                                // Si está en 0 (o vacío), limpiamos al hacer foco
                                if (row.porcentaje === 0) {
                                  handleCentroCostoRowChange(index, 'porcentaje', '')
                                }
                              }}
                              onBlur={e => {
                                // Si lo deja vacío, volvemos a 0 para no guardar vacío
                                if (e.target.value === '') {
                                  handleCentroCostoRowChange(index, 'porcentaje', 0)
                                }
                              }}
                              onChange={e =>
                                handleCentroCostoRowChange(index, 'porcentaje', e.target.value)
                              }
                              disabled={data.validation === -5}
                            />

                            {centrosCostoRows.length > 0 && (
                              <button
                                type='button'
                                onClick={() => removeCentroCostoRow(index)}
                                className='text-red-500 hover:text-red-700 flex items-center justify-center'
                                title='Eliminar centro de costo'
                              >
                                <ClearOutlinedIcon fontSize='small' />
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  {centroCostoError && (
                    <p className='text-xs text-red-500 mt-1'>{centroCostoError}</p>
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
        )}
    </>
    </ResizableModal>
  )
}

export default ModalCentroCosto
